// extracted by mini-css-extract-plugin
export default {"header":"MapHeader_header__8fm6a","title":"MapHeader_title__idKW2","liveBadge":"MapHeader_liveBadge__GkSkI"};